import gql from 'graphql-tag';

export default gql`
  query allSchoolsLookup {
    allSchools {
      id
      schoolId
      name
      districtId
      districtName
    }
  }
`;
